import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import { Autocomplete, Box, Stack, TextField, Typography } from '@mui/material'

const VehicleSelector = ({ form, handleChange }) => {
  const [loadingVehicles, setLoadingVehicles] = useState(true)
  const [loadingError, setLoadingError] = useState(false)
  const [vehicles, setVehicles] = useState([])

  useEffect(() => {
    API.get('/vehicles?type=PTS')
      .then((res) => res.status === 200 && setVehicles(res.data))
      .catch((e) => setLoadingError(true))
      .finally(() => setLoadingVehicles(false))
  }, [])

  return (
    <Autocomplete
      options={vehicles}
      getOptionLabel={(o) => `${o.callSign} - ${o.regPlate}`}
      renderOption={(props, o) => {
        const { key, ...optionProps } = props

        return (
          <li key={key} {...optionProps}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              padding={1}
              width="100%"
            >
              <Typography>{o.callSign}</Typography>

              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius={1}
                sx={{ backgroundColor: '#FFD307' }}
              >
                <Typography
                  fontFamily="UKnumberplate"
                  fontSize={12}
                  padding={0.5}
                >
                  {o.regPlate}
                </Typography>
              </Box>
            </Stack>
          </li>
        )
      }}
      value={form.vehicle}
      renderInput={(params) => <TextField {...params} label="Vehicle" />}
      onChange={(e, value) => {
        handleChange('vehicle', value)
      }}
      isOptionEqualToValue={(o, v) => o._id === v._id}
      loading={loadingVehicles}
      loadingText={
        loadingError ? 'Unable to load vehicles' : 'Loading vehicles'
      }
    />
  )
}

export default VehicleSelector
